module.exports = __webpack_public_path__ + "img/character_details.ddaf0169.png";